import {
  createPlateUI,
  ELEMENT_H1,
  ELEMENT_H2,
  ELEMENT_H3,
  ELEMENT_H4,
  ELEMENT_H5,
  ELEMENT_H6,
  ELEMENT_PARAGRAPH,
  ELEMENT_LINK,
  ELEMENT_UL,
  ELEMENT_OL,
  ELEMENT_LI,
  ELEMENT_TODO_LI,
  ELEMENT_MEDIA_EMBED,
  ELEMENT_TABLE,
  ELEMENT_TD,
  ELEMENT_TH,
  ELEMENT_IMAGE,
  MARK_FONT_FAMILY,
  MARK_FONT_SIZE,
  MARK_FONT_WEIGHT,
  MARK_BG_COLOR,
  MARK_COLOR,
  StyledElement,
  withProps,
} from '@udecode/plate';

import { MarkElement } from './components/elements/MarkElement';
import { TodoListElement } from './plugins/todo-list/ToDoListElement';
import { PlateTableElement } from './plugins/table/PlateTableElement';
import { PlateTableCellElement } from './plugins/table/PlateTableCellElement';
import { ELEMENT_PAGE_BREAK } from './plugins/page-break/createPageBreakPlugin';
import { PageBreakElement } from './plugins/page-break/PageBreakElement';
import { ImageElement } from './plugins/media/images/ImageElement';
import { MediaEmbedElement } from './plugins/media/embed/MediaEmbedElement';
import { ListItemElement } from './plugins/list/ListItemElement';
import { LinkElement } from './plugins/link/LinkElement';
import { NOTE_HEADER, NOTE_HEADER_VOID } from './plugins/layout/note-layout/createNoteLayoutPlugin';
import { NoteHeaderElement } from './plugins/layout/note-layout/NoteHeaderElement';
import { ELEMENT_MERGE_FIELD, ELEMENT_SMART_INPUT } from './plugins/merge-fields/createMergeFieldsPlugin';
import { MergeFieldElement } from './plugins/merge-fields/MergeFieldElement';
import { SmartInputElement } from './plugins/merge-fields/SmartInputElement';

export const plateUI = createPlateUI({
  [ELEMENT_H1]: withProps(StyledElement, { as: 'h1' }),
  [ELEMENT_H2]: withProps(StyledElement, { as: 'h2' }),
  [ELEMENT_H3]: withProps(StyledElement, { as: 'h3' }),
  [ELEMENT_H4]: withProps(StyledElement, { as: 'h4' }),
  [ELEMENT_H5]: withProps(StyledElement, { as: 'h5' }),
  [ELEMENT_H6]: withProps(StyledElement, { as: 'h6' }),
  [ELEMENT_PARAGRAPH]: withProps(StyledElement, { as: 'p' }),
  [ELEMENT_LINK]: LinkElement,
  [ELEMENT_OL]: withProps(StyledElement, { as: 'ol' }),
  [ELEMENT_UL]: withProps(StyledElement, { as: 'ul' }),
  [ELEMENT_LI]: ListItemElement,
  [ELEMENT_TODO_LI]: TodoListElement,
  [ELEMENT_IMAGE]: ImageElement,
  [ELEMENT_MEDIA_EMBED]: withProps(MediaEmbedElement, {
    caption: { disabled: true },
  }),
  [ELEMENT_TABLE]: PlateTableElement,
  [ELEMENT_TD]: PlateTableCellElement,
  [ELEMENT_TH]: PlateTableCellElement,
  [ELEMENT_PAGE_BREAK]: PageBreakElement,
  [NOTE_HEADER]: NoteHeaderElement,
  [NOTE_HEADER_VOID]: NoteHeaderElement,
  [ELEMENT_MERGE_FIELD]: MergeFieldElement,
  [ELEMENT_SMART_INPUT]: SmartInputElement,
});

export const serializePlateUI = createPlateUI({
  [ELEMENT_H1]: withProps(StyledElement, { as: 'h1' }),
  [ELEMENT_H2]: withProps(StyledElement, { as: 'h2' }),
  [ELEMENT_H3]: withProps(StyledElement, { as: 'h3' }),
  [ELEMENT_H4]: withProps(StyledElement, { as: 'h4' }),
  [ELEMENT_H5]: withProps(StyledElement, { as: 'h5' }),
  [ELEMENT_H6]: withProps(StyledElement, { as: 'h6' }),
  [ELEMENT_PARAGRAPH]: withProps(StyledElement, { as: 'p' }),
  [ELEMENT_OL]: withProps(StyledElement, { as: 'ol' }),
  [ELEMENT_UL]: withProps(StyledElement, { as: 'ul' }),
  [ELEMENT_LINK]: LinkElement,
  [ELEMENT_LI]: ListItemElement,
  [ELEMENT_TODO_LI]: TodoListElement,
  [ELEMENT_IMAGE]: ImageElement,
  [ELEMENT_MEDIA_EMBED]: withProps(MediaEmbedElement, {
    caption: { disabled: true },
  }),
  [ELEMENT_TABLE]: PlateTableElement,
  [ELEMENT_TD]: PlateTableCellElement,
  [ELEMENT_TH]: PlateTableCellElement,
  [ELEMENT_PAGE_BREAK]: PageBreakElement,
  [MARK_FONT_FAMILY]: MarkElement,
  [MARK_FONT_SIZE]: MarkElement,
  [MARK_FONT_WEIGHT]: MarkElement,
  [MARK_COLOR]: MarkElement,
  [MARK_BG_COLOR]: MarkElement,
  [NOTE_HEADER]: NoteHeaderElement,
  [NOTE_HEADER_VOID]: NoteHeaderElement,
});
